<template>
    <div>
        <div class="panel-tag mt-3" v-if="commissionItems.length == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-else class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <!-- <div class="fs-xs fw-300 text-right pt-2 pb-2">
                        <button type="button" class="btn btn-xs btn-outline-primary waves-effect waves-themed mr-2" @click="showAllDetails">{{isExpand == 'Expand' ? $t('button_link.expand_details') : $t('button_link.collapse_details')}} </button>
                    </div> -->
                    <b-table id="salesItemTable" striped hover bordered :sort-compare="sortTable" :fields="fields" :items="commissionItems" responsive>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(title)="data">
                            <a class="fw-500 text-primary link" title="View Details" :id="'salesItems_' + data.item.completedID" @click="showDetails($event)">{{data.item.item.title}}</a>
                            <div class="mt-1 salesItemDetail" style="display: none;">
                                <b-table-simple class="table table-sm table-hover table-bordered table-striped">
                                    <b-tr>
                                        <b-th>{{$t('table.header.date')}}</b-th>
                                        <b-td>{{convertTimestampToDateTime(data.item.createDate)}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.receipt_number')}}</b-th>
                                        <b-td>
                                            <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(data.item.salesID)">
                                                {{insertLeadingZero(data.item.receiptID)}}
                                                <i class="fal fa-print"></i>
                                            </a>
                                        </b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.outlet')}}</b-th>
                                        <b-td>{{getOutletName(data.item.outletID)}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('subMenu.my_salon_member') + $t('table.header.name')}}</b-th>
                                        <b-td>{{data.item.member.displayName}}</b-td>    
                                    </b-tr>
                                    <b-tr>
                                        <b-th>{{$t('table.header.contact')}}</b-th>
                                        <b-td>
                                            <a class="fw-400 text-primary link" title="Edit Member">
                                                {{data.item.member.mobile}}
                                                <i class="fal fa-pen"></i>
                                            </a>
                                        </b-td>    
                                    </b-tr>
                                </b-table-simple>    
                            </div>
                        </template>
                        <template #cell(date)="data">{{convertTimestampToDateTime(data.item.createDate)}}</template>
                        <template #cell(outlet)="data">{{getOutletName(data.item.outletID)}}</template>
                        <template #cell(receipt)="data">
                            <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(data.item.salesID)">
                                {{insertLeadingZero(data.item.receiptID)}}
                                <i class="fal fa-print"></i>
                            </a>
                        </template>
                        <template #cell(price)="data">{{formatPrice(data.item.price)}}</template>
                        <template #cell(discount)="data">{{formatPrice(data.item.discount)}}</template>
                        <template #cell(outstandings)="data">{{formatPrice(data.item.outstandings)}}</template>
                        <template #cell(subtotal)="data">{{formatPrice(data.item.subtotal)}}</template>

                        <template #cell(position1)="data">{{data.item.position1}}</template>
                        <template #cell(cmss1)="data">{{formatPrice(data.item.cmss1)}}</template>
                        <template #cell(effort1)="data">{{formatPrice(data.item.effort1)}}</template>
                        <template #cell(percent1)="data">{{formatPrice(data.item.percent1)}}</template>
                        <template #cell(fee1)="data">{{formatPrice(data.item.fee1)}}</template>

                        <template #cell(position2)="data">{{data.item.position2}}</template>
                        <template #cell(effort2)="data">{{formatPrice(data.item.effort2)}}</template>
                        <template #cell(cmss2)="data">{{formatPrice(data.item.cmss2)}}</template>
                        <template #cell(percent2)="data">{{formatPrice(data.item.percent2)}}</template>
                        <template #cell(fee2)="data">{{formatPrice(data.item.fee2)}}</template>

                        <template #cell(position3)="data">{{data.item.position3}}</template>
                        <template #cell(effort3)="data">{{formatPrice(data.item.effort3)}}</template>
                        <template #cell(cmss3)="data">{{formatPrice(data.item.cmss3)}}</template>
                        <template #cell(percent3)="data">{{formatPrice(data.item.percent3)}}</template>
                        <template #cell(fee3)="data">{{formatPrice(data.item.fee3)}}</template>

                        <template #cell(position4)="data">{{data.item.position4}}</template>
                        <template #cell(effort4)="data">{{formatPrice(data.item.effort4)}}</template>
                        <template #cell(cmss4)="data">{{formatPrice(data.item.cmss4)}}</template>
                        <template #cell(percent4)="data">{{formatPrice(data.item.percent4)}}</template>
                        <template #cell(fee4)="data">{{formatPrice(data.item.fee4)}}</template>

                        <!-- <template #custom-foot>
                            <b-tr>
                                <b-td colspan="2" class="border-top-bottom-2 text-right fw-700">{{$t('label.total')}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalPrice)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalDiscount)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalOutstandings)}}</b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.totalTax)}}</b-td>
                                <b-td class="border-top-bottom-2 disabled-td"></b-td>
                                <b-td class="border-top-bottom-2 fw-500">{{formatPrice(objTotalData.subTotal)}}</b-td>
                                <b-td class="border-top-bottom-2 disabled-td"></b-td>
                            </b-tr>
                        </template> -->
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {calculateSalesReportTotal, getSubTotal} from '@/assets/js/dashboard/salonReport/salonReport.js'
import {getOutletName, handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
import {formatPrice, insertLeadingZero} from '@/assets/js/dashboard/utilities.js'
export default {
    name: "salesDate",
    props:{
        commissionSalesItem: { type: Array }
    },
    data(){
        return{
            commissionItems: [], 
            objTotalData: {},
            isExpand: "Expand",
        }
    },
    computed:{
        fields(){
            let list = [
                {key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "date", label: 'Date', thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "outlet", label: 'Outlet', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "receipt", label: "Receipt Number", thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "mobile", label: 'Mobile', thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "voucher", label: "Item", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "_itemType", label: "Type", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "_paymentMethod", label: "Payment", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "discount", label: "Discount", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "outstandings", label: "Outstanding", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
                {key: "subtotal", label: "Subtotal", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
            ]

            for(let i=1; i<=2; i++) {
                list.push(
                    {key: "Staff" + i, label: "Staff " + i, thClass: 'thead-themed align-middle bg-staff' + i, tdClass: 'align-middle bg-staff' + i, asortable: false},
                    {key: "position" + i, label: "Position", thClass: 'thead-themed align-middle bg-staff' + i, tdClass: 'align-middle bg-staff' + i, asortable: false},
                    {key: "effort" + i, label: "Effort", thClass: 'thead-themed align-middle bg-staff' + i, tdClass: 'align-middle bg-staff' + i, asortable: false},
                    {key: "percent" + i, label: "Commission (%)", thClass: 'thead-themed align-middle bg-staff' + i, tdClass: 'align-middle bg-staff' + i, asortable: false},
                    {key: "cmss" + i, label: "Commission", thClass: 'thead-themed align-middle bg-staff' + i, tdClass: 'align-middle bg-staff' + i, asortable: false},
                )
            }

            list.push(
                {key: "_error", label: "Error", thClass: 'thead-themed align-middle', tdClass: 'align-middle', asortable: false},
            )

            return list
        }
    },
    methods:{
        getOutletName(id){
            return getOutletName(id, JSON.parse(this.$store.state.outlets));
        },
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        convertTimestampToDateTime(ts){
            return moment.unix(ts).format(this.$msg.CST.DATE_TIME_24);
        },
        formatPrice(p){
            if(p === '' || p === null || p === undefined) {
                return ''
            }
            return formatPrice(p);
        },

        sortTable(a, b, key){
            if(key == "title"){
                var aTitle = a.item.title
                var bTitle = b.item.title
                return aTitle.localeCompare(bTitle);
            }else if(key == 'subTotal'){
                var aTotal = getSubTotal(a.price, a.discount, a.outstandings, a.tax.taxType, a.tax.tax)
                var bTotal = getSubTotal(b.price, b.discount, b.outstandings, a.tax.taxType, a.tax.tax)
                return aTotal - bTotal
            }else if(key == 'date'){
                return a.createDate - b.createDate
            }else if(key == 'receipt'){
                return a.receiptID - b.receiptID
            }
            return false
        },
        updateTable(items, filterObj){
            this.commissionItems = items
            this.setExportData(items, filterObj)
        },
        getTotalData(item){
            var objTotalData = calculateSalesReportTotal(item)
            this.$emit('setTotalData', objTotalData)
        },
        getSubTotal(price, discount, outstandings, taxType, tax){
            return getSubTotal(price, discount, outstandings, taxType, tax)
        },

        showAllDetails(){   
            var isExpand = false;
            if(this.isExpand == "Expand"){
                isExpand = true;
                this.isExpand = "Collapse"
            }else{
                isExpand = false;
                this.isExpand = "Expand"
            }
            var detailsContainer = document.getElementById("salesItemTable").querySelectorAll(".salesItemDetail");
            for(var i=0; i<detailsContainer.length; i++){
                if(isExpand){
                    if(detailsContainer[i].style.display == 'none'){
                        detailsContainer[i].style.display = 'block'
                    }
                }else{
                    if(detailsContainer[i].style.display == 'block'){
                        detailsContainer[i].style.display = 'none'
                    }
                }
            }
        },
        showDetails(e){
            var link = e.target.id;
            var detailsDiv = document.getElementById(link).nextSibling;
            detailsDiv.style.display = detailsDiv.style.display == 'none' ? 'block' : 'none';

            var hideCount = 0;
            var detailsContainer = document.getElementById("salesItemTable").querySelectorAll(".salesItemDetail");

            for(var i=0; i<detailsContainer.length; i++){
                if(detailsContainer[i].style.display == 'none'){
                    hideCount++
                }
            }

            this.isExpand = hideCount == this.commissionItems.length ? "Expand" : "Collapse"
        },

        generateReceipt(salesID){
            let $vm = this
            const QUERY_STRING = "/" + salesID + "/receipt";
            const url =  this.$api.REPORT_SALES + QUERY_STRING;

            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                if(response.status == 200){
                    var path = response.data.path;
                    window.open(path, '_blank');
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
        },

        setExportData(group, filterObj) {
            this.exportFields = {}
            this.exportFields["#"] = "index";
            this.exportFields['DATE'] = "date"
            this.exportFields['OUTLET'] = "outlet"
            this.exportFields['RECEIPT'] = "receipt"
            this.exportFields['MOBILE'] = "mobile"
            this.exportFields['ITEM'] = "item"
            this.exportFields['TYPE'] = "type"
            this.exportFields['PAYMENT'] = "payment"
            this.exportFields['DISCOUNT'] = "discount"
            this.exportFields['OUTSTANDING'] = "outstanding"
            this.exportFields['SUBTOTAL'] = "subtotal"
            for(let i=1; i<=4; i++) {
                this.exportFields['STAFF ' + i] = "staff" + i
                this.exportFields['POSITION ' + i] = "position" + i
                this.exportFields['COMMISSION PERCENT ' + i] = "percent" + i
                this.exportFields['COMMISSION ' + i] = "commission" + i
                this.exportFields['FEE ' + i] = "fee" + i
            }

            var exportData = []

            for (var k = 0; k < group.length; k++) {
                var obj = {
                    'index': k + 1,
                    'date': this.convertTimestampToDateTime(group[k]['createDate']),
                    'outlet': this.getOutletName(group[k]['outletID']),
                    'receipt': this.insertLeadingZero(group[k]['receiptID']),
                    'mobile': group[k]['mobile'] || '',
                    'item': group[k]['voucher'] || '',
                    'type': group[k]['_itemType'] || '',
                    'payment': group[k]['_paymentMethod'] || '',
                    'discount': this.formatPrice(group[k]['discount']),
                    'outstanding': this.formatPrice(group[k]['outstandings']),
                    'subtotal': this.formatPrice(group[k]['subtotal']),
                }

                for(let i=1; i<=4; i++) {
                    obj['staff' + i] = group[k]['Staff' + i] || ''
                    obj['position' + i] = group[k]['position' + i] || ''
                    obj['percent' + i] = this.formatPrice(group[k]['pctg' + i])
                    obj['commission' + i] = this.formatPrice(group[k]['cmss' + i])
                    obj['fee' + i] = this.formatPrice(group[k]['fee' + i])
                }

                obj['Error'] = group[k]['error'] || ''

                exportData.push(obj)
            }

            var strDate = moment(filterObj.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.endDate).format(this.$msg.CST.DATE_FORMAT);

            let header = this.$msg.REPORT.HEADER + 'Sales'
            var exportHeaders = [
                this.$msg.REPORT.HEADER + 'Sales',
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24),
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet == "all" ? this.$i18n.t('label.all', { 'item': this.$i18n.t('label.outlet') }) : this.getOutletName(filterObj.outlet)),
                " "];
            var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName,
                exportFields: this.exportFields
            }
            this.$emit('setExportData', data)
        },
    },
    mounted(){
        let $vm = this;
        $vm.commissionItems = $vm.commissionSalesItem
        $vm.getTotalData($vm.commissionItems);
    }
}
</script>
<style scoped>
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,
.btn-outline-primary:hover{
    background: transparent;
    color: #62468d !important;
}

.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}

.disabled-td{
    background: #e9e9e9;
}
</style>